export const TAGS = [
  'CampaignAnalyticsReports',
  'LocationListExclusion',
] as const;
